import axios from "axios";
import { baseUrl } from "../config/url";

export interface IParams {
  rate_id: string | undefined;
  partner_name: string;
  symbol_from: string;
  network_from: string;
  symbol_to: string;
  network_to: string;
  amount: string | undefined;
  fixed: boolean;
  token_id: string | null;
  to_address: string | undefined;
  extera_id?: string | undefined;
  refund_address?: string | undefined;
  refund_extera_id?: string | undefined;
}

export interface IRes {
  Status: string;
  Message?: string;
  exchangeID?: string;
}

export const createExchangeService = (param: IParams) =>
  axios.post<IRes>(`${baseUrl}createNewExchange`, param, { withCredentials: true });
